import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

function centeringActiveTab(tab) {
  const tabList = document.querySelector(
    '[data-discount-code-template-smart-home-tabs]'
  );
  const offsetLeft =
    tab.offsetLeft + tab.offsetWidth / 2 - window.innerWidth / 2;

  tabList.scrollLeft = offsetLeft;
}

export const initSmartHomeSlider = () => {
  const smartHomeSliderEl = document.querySelector(
    '[data-discount-code-template-smart-home-slider]'
  );

  const smartHomeSlider = new Splide(smartHomeSliderEl, {
    type: 'loop',
    rewind: true,
    perPage: 1,
    autoplay: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    interval: 3000,
    speed: 1200,
    drag: true,
    arrows: false,
    pagination: true,
    cssEase: 'linear',
    intersection: {
      inView: {
        autoplay: true,
      },
      outView: {
        autoplay: false,
      },
    },
    classes: {
      pagination:
        'discount-code-template-smart-home__slider-pagination splide__pagination',
      page: 'discount-code-template-smart-home__slider-pagination-btn splide__pagination__page',
    },
  });

  smartHomeSlider.mount({ Intersection });

  const tabs = document.querySelectorAll(
    '[data-discount-code-template-smart-home-tab]'
  );
  const ACTIVE_DATA_ATTR = 'data-active';

  tabs.forEach((tab, tabIndex) => {
    tab.addEventListener('click', () => {
      const activeTab = document.querySelector(
        `[data-discount-code-template-smart-home-tab][${ACTIVE_DATA_ATTR}="true"]`
      );

      activeTab.setAttribute(ACTIVE_DATA_ATTR, 'false');
      tab.setAttribute(ACTIVE_DATA_ATTR, 'true');
      centeringActiveTab(tab);
      smartHomeSlider.go(tabIndex);
    });
  });

  smartHomeSlider.on('move', (newIndex, currentIndex) => {
    tabs[currentIndex].setAttribute(ACTIVE_DATA_ATTR, 'false');
    tabs[newIndex].setAttribute(ACTIVE_DATA_ATTR, 'true');
    centeringActiveTab(tabs[newIndex]);
  });
};
